import { render, staticRenderFns } from "./index.vue?vue&type=template&id=436dac86&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436dac86')) {
      api.createRecord('436dac86', component.options)
    } else {
      api.reload('436dac86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=436dac86&", function () {
      api.rerender('436dac86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/u8sdk/permission/alarm/index.vue"
export default component.exports